export const computedInternalUrl = `
  select(
    defined(parentPage->parentPage->slug.current) => "/products/" + parentPage->parentPage->slug.current + "/" + parentPage->slug.current + "/" + slug.current,
    defined(parentPage->slug.current) => "/products/" + parentPage->slug.current + "/" + slug.current,
    _type == "productsList" => "/products/" + category->slug.current + "/" + slug.current,
    _type == "product" && defined(subcategory->parentCategory->slug.current) => "/products/" + subcategory->parentCategory->slug.current + "/" + subcategory->slug.current + "/" + slug.current,
    _type == "structaProductLevel1" => "/products/" + slug.current,
    _type == "articlesList" => "/" + select(
      type == "blogs" => "blog",
      type
    ),
    _type == "article" && defined(type) && type == "blogs" => "/blog/" + slug.current,
    _type == "article" && defined(type) => "/" + type + "/" + slug.current,
    _type == "documentPage" => "/documents/" + slug.current,
    _type == "faqs" => "/faq",
    _type == "contactUs" => "/contact-us",
    _type == "storeLocator" => "/store-locator",
    _type == "homePage" => "/",
    "/" + slug.current
  )
`;

export const internalReferenceUrl = `
  select(
    type == "internal" =>
      internalReference->{
        "computedUrl": ${computedInternalUrl}
      }.computedUrl,
    url
  )
`;

export const directInternalReferenceUrl = `
  select(
    link.type == "internal" =>
      link.internalReference->{
        "computedUrl": ${computedInternalUrl}
      }.computedUrl,
    link.url
  )
`;

export const LOGO_PROJECTTION = `
  logo{
    ...,
    link{
      ...,
      "url": ${internalReferenceUrl},
    },
    "imageUrl": logo.asset->url,
  }
`;

export const imageProjection = `
  ...,
  "alt": coalesce(alt, asset->altText),
  "title": coalesce(title, asset->title),
  "url": asset->url,
`;
